const t = "text-[16px] sm:text-sm", _ = "px-4 py-2.5";
export {
  t as FONT_SIZE_CLASS_NAME,
  _ as FORM_ELEMENT_PADDING_CLASS_NAME
};
